import g from "lodash/isPlainObject.js";
const i = typeof window != "undefined" ? window : {}, E = (e, t = i.document.cookie) => {
  var n;
  return t && ((n = t.split("; ").find((s) => s.startsWith(`${e}=`))) == null ? void 0 : n.split("=")[1]);
}, S = () => E("rrUserId") || "", P = async () => {
  var e;
  try {
    return await ((e = i == null ? void 0 : i.metrics) == null ? void 0 : e.getVisitorId());
  } catch {
    return "";
  }
}, v = async () => {
  var t;
  if (!i) return;
  const e = await P();
  e != null && e.length && ((t = i.R3_COMMON) == null || t.setSessionId(e));
}, T = () => {
  var n, s, o;
  if (!i) return;
  const e = i.location.host.split(".")[0], t = (n = i.rr_v) != null && n.startsWith("1.2") ? "richrelevance" : "algorecs";
  e === "corp" || e === "www" ? (s = i.R3_COMMON) == null || s.setBaseUrl(`https://recs.${t}.com/rrserver/`) : (o = i.R3_COMMON) == null || o.setBaseUrl(`https://integration.${t}.com/rrserver/`);
}, b = async () => {
  if (typeof (i == null ? void 0 : i.r3_common) == "undefined")
    throw new Error("cannot find r3_common on global scope as required for Rich Relevance, may be missing p13n.js");
  i.R3_COMMON = new i.r3_common(), i.R3_COMMON.setApiKey("30280c406d639577"), T(), i.R3_COMMON.setClickthruServer(`${i.location.origin}`);
  const e = S();
  e !== "" ? (i.R3_COMMON.setUserId(e), i.R3_COMMON.addSegment("member", "member")) : i.R3_COMMON.addSegment("non-member", "non-member"), await v();
}, l = typeof window != "undefined" ? window : {}, w = (e) => typeof e == "function", O = (e) => {
  l && (l.location.href = e);
}, A = () => {
  var e, t, n;
  return (n = (t = (e = l == null ? void 0 : l.RR) == null ? void 0 : e.data) == null ? void 0 : t.JSON) == null ? void 0 : n.placements;
}, G = (e) => {
  const t = A(), n = structuredClone(t);
  return t ? n && n.filter(
    (s) => e === s.placementName
  )[0] : (console.warn("could not get placements from RR.data.JSON"), null);
}, N = (e) => fetch(e, {
  mode: "cors"
}).then((t) => (t.status !== 200 && console.warn(`Rich Relevance Server click returning status code ${t.status}, url: ${e}`), t)).catch((t) => (console.warn(`Rich Relevance Server click is failing with error: ${t}, url: ${e}`), t)), H = (e, t) => new Promise((n) => {
  w(e) && g(t) ? e(t) : (w(e) || console.warn("analyticsClickHandler must be a function"), g(t) || console.warn("analyticsConfig must be an object")), n();
}), L = (e) => (t) => {
  if (!l) return;
  const {
    event: n,
    rrClickUrl: s,
    analyticsConfig: o,
    redirectHref: f
  } = t;
  if (!f) {
    console.warn("no href provided for redirect!");
    return;
  }
  n.preventDefault(), Promise.all([
    N(s),
    H(e, o)
  ]).then(() => {
    O(f);
  }).catch((d) => {
    console.warn(`failure in handleRRClick, error: ${d}`), O(f);
  });
}, W = () => {
  var n, s;
  if (!l) return;
  const e = JSON.stringify((s = (n = l == null ? void 0 : l.RR) == null ? void 0 : n.data) == null ? void 0 : s.JSON), t = new CustomEvent("rr-json-data-loaded", {
    detail: e
  });
  window.document.dispatchEvent(t);
}, x = (e) => {
  l != null && l.RR && (l.RR.jsonCallback = function() {
    W(), e && typeof e == "function" && e();
  });
}, R = typeof window != "undefined" ? window : {}, B = () => {
  var e, t;
  R && ((e = R.rr_flush_onload) == null || e.call(R), (t = R.r3) == null || t.call(R));
}, u = typeof window != "undefined" ? window : {}, I = () => {
  [
    "R3_ITEM",
    "R3_SEARCH",
    "R3_CATEGORY",
    "R3_WISHLIST",
    "R3_CART"
  ].forEach((e) => {
    e in u && delete u[e];
  }), u.RR && (u.RR.jsonCallback = () => {
  }), u.R3_COMMON && (u.R3_COMMON.placementTypes = "");
}, D = typeof window != "undefined" ? window : {}, j = (e) => {
  if (!e || typeof e != "function")
    throw new Error("pageContextCB is required and should be a function");
}, F = (e = "") => {
  if (!Array.isArray(e) && e.length)
    throw new Error("If using placements, make sure it is passed in as an array");
}, J = async (e) => {
  const {
    pageContextCB: t,
    customFilters: n,
    rrCallback: s,
    placements: o,
    reset: f
  } = e;
  try {
    j(t), F(o), f || await b(), f && I(), t(), Array.isArray(n) && n.length && n.forEach((d) => {
      typeof d == "function" && d();
    }), o && o.forEach((d) => {
      var h;
      (h = D.R3_COMMON) == null || h.addPlacementType(d);
    }), x(s), B();
  } catch (d) {
    d instanceof Error && console.error(`Error interacting with third party (RichRelevance). message: ${d.message}`);
  }
}, C = typeof window != "undefined" ? window : {}, V = (e) => new Promise((t, n) => {
  const s = C.document.createElement("script");
  if (s.onload = () => {
    t();
  }, s.onerror = (o) => {
    console.warn("script was not able to load via @rei/recommendations loadScript"), n(o);
  }, e)
    s.src = e;
  else {
    const o = C.location.host.split(".")[0], d = o === "corp" || o === "www" ? "https://www.rei.com/satchel" : "https://satchel-stage.rei.com";
    s.src = `${d}/packages/rich-relevance/p13n.js`;
  }
  C.document.head.appendChild(s);
}), a = typeof window != "undefined" ? window : {}, m = (e, t) => {
  !Array.isArray(e) || !e.length || typeof t == "function" && e && e.slice(0, 15).forEach((n) => t(n));
}, y = (e) => {
  var t;
  (t = a == null ? void 0 : a.R3_COMMON) == null || t.addCategoryHintId(e);
}, Y = (e) => {
  e.forEach((t) => {
    var n;
    return (n = a == null ? void 0 : a.R3_COMMON) == null ? void 0 : n.blockItemId(t);
  });
}, q = (e) => {
  var t;
  (t = a == null ? void 0 : a.R3_COMMON) == null || t.setPageBrand(e);
}, K = (e) => {
  var t;
  e.forEach((n) => {
    var s;
    return (s = a == null ? void 0 : a.R3_COMMON) == null ? void 0 : s.addFilterBrand(n);
  }), (t = a == null ? void 0 : a.R3_COMMON) == null || t.setFilterBrandsIncludeMatchingElements("true");
}, r = typeof window != "undefined" ? window : {}, Q = (e, t, n) => {
  r != null && r.r3_item && (r.R3_ITEM = new r.r3_item(), e && r.R3_ITEM.setId(e), t && r.R3_ITEM.setName(t), n && y(n));
}, z = (e, t) => {
  r != null && r.r3_search && (r.R3_SEARCH = new r.r3_search(), e && r.R3_SEARCH.setTerms(e), t && m(t, (n) => {
    var s;
    return (s = r.R3_SEARCH) == null ? void 0 : s.addItemId(n);
  }));
}, X = (e) => {
  r != null && r.r3_brand && (r.R3_BRAND = new r.r3_brand(), q(e));
}, Z = (e, t, n) => {
  r != null && r.r3_category && (r.R3_CATEGORY = new r.r3_category(), e && r.R3_CATEGORY.setId(e), t && r.R3_CATEGORY.setName(t), n && m(n, (s) => {
    var o;
    return (o = r.R3_COMMON) == null ? void 0 : o.addItemId(s);
  }));
}, $ = (e, t) => {
  r != null && r.r3_addtocart && (r.R3_ADDTOCART = new r.r3_addtocart(), e && r.R3_ADDTOCART.addItemIdToCart(e.substring(0, 6), e), t && y(t));
}, ee = (e, t) => {
  var n;
  r != null && r.r3_cart && (r.R3_CART = new r.r3_cart(), t && ((n = r.R3_COMMON) == null || n.setCartValue(t)), e && m(e, (s) => {
    var o;
    return (o = r.R3_CART) == null ? void 0 : o.addItemId(s.substring(0, 6), s);
  }));
}, te = (e, t) => {
  r != null && r.r3_purchased && (r.R3_PURCHASED = new r.r3_purchased(), e && r.R3_PURCHASED.setOrderNumber(e), Array.isArray(t) && t.length > 0 ? t.forEach((n) => {
    var d;
    const {
      price: s,
      qty: o,
      sku: f
    } = n;
    if (s && o && f) {
      const h = f.substring(0, 6);
      (d = r.R3_PURCHASED) == null || d.addItemIdPriceQuantity(h, s, o, f);
    } else
      console.warn("item is missing one or more required properties: price, qty, sku");
  }) : console.warn("cartItems is required and must be an array"));
}, re = () => {
  r != null && r.r3_home && (r.R3_HOME = new r.r3_home());
}, ne = () => {
  r != null && r.r3_error && (r.R3_ERROR = new r.r3_error());
}, se = () => {
  r != null && r.r3_generic && (r.R3_GENERIC = new r.r3_generic());
}, c = typeof window != "undefined" ? window : {}, _ = (e) => e.substring(0, 6);
function oe(e, t = []) {
  if (!c.r3_wishlist) throw new Error("cannot find r3_wishlist on global scope as required, may be missing p13n.js");
  c.R3_WISHLIST = new c.r3_wishlist(), m(t, (n) => {
    var o;
    const s = _(n);
    (o = c.R3_WISHLIST) == null || o.addViewItemIdInWishlist(s, n, e);
  });
}
const U = () => {
  var e;
  c.RR && (Object.keys((e = c.RR) == null ? void 0 : e.registeredPageTypes).forEach((t) => {
    var n, s;
    t !== "COMMON" && ((s = c.RR) == null || s.unregisterPageType((n = c.RR) == null ? void 0 : n.registeredPageTypes[t]));
  }), I());
}, p = (e) => {
  var t;
  if (!c.r3_wishlist) throw new Error("cannot find r3_wishlist on global scope as required, may be missing p13n.js");
  U(), c.R3_WISHLIST = new c.r3_wishlist(), e(c.R3_WISHLIST), (t = c.r3) == null || t.call(c);
}, ie = (e, t) => {
  p((n) => {
    const s = _(e);
    n.addItemIdToWishlist(s, e, t);
  });
}, M = (e, t) => {
  p((n) => {
    e.forEach((s) => {
      const o = _(s);
      n.removeItemIdFromWishlist(o, s, t);
    });
  });
}, ce = M, ae = (e, t) => {
  M([e], t);
}, de = (e) => {
  const t = "Save-For-Later";
  p((n) => {
    m(e, (s) => {
      const o = _(s);
      n.addViewItemIdInWishlist(o, s, t);
    });
  });
};
export {
  K as addBrandFilters,
  y as addCategoryHint,
  ie as addItemToWishlist,
  L as buildRRClickHandler,
  J as default,
  G as getPlacementData,
  P as getSessionId,
  S as getUserId,
  de as initWishlistOnCart,
  B as launchRecs,
  V as loadScript,
  W as recsDataLoadedEvent,
  ae as removeItemFromWishlist,
  ce as removeWishlist,
  I as resetRR,
  $ as setAddToCartPageContext,
  Y as setBlockedItems,
  X as setBrandPageContext,
  ee as setCartPageContext,
  Z as setCategoryPageContext,
  ne as setErrorPageContext,
  se as setGenericPageContext,
  b as setGlobalContext,
  re as setHomePageContext,
  Q as setItemPageContext,
  q as setPageBrand,
  te as setPurchasedPageContext,
  x as setRRCallback,
  z as setSearchPageContext,
  oe as setWishlistPageContext
};
